// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2rDib","label":"Completed_label__1s67F"};